import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

export const studentsAdapter = createEntityAdapter();

export const initialState = studentsAdapter.getInitialState({
    chosenStudent: null,
    conflicts: [],
    conflictsLoading: false,
    conflictsCheckedAt: null,
})

const studentsSlice = createSlice({
    name: 'students',
    initialState,
    reducers: {
        studentsSetAll: (state, action) => {
            studentsAdapter.setAll(state, action.payload);
        },
        studentAddOne: (state, action) => {
            studentsAdapter.addOne(state, action.payload);
        },
        studentUpdateOne: (state, action) => {
            studentsAdapter.updateOne(state, {
                id: action.payload.studentId,
                changes: {
                    name: action.payload.name,
                    birthDate: action.payload.birthDate,
                    stickers: action.payload.stickers,
                }
            });
        },
        studentRemoveOne: (state, action) => {
            studentsAdapter.removeOne(state, action.payload);
        },
        addChosenStudent: (state, action) => {
            state.chosenStudent = action.payload
        },
        removeChosenStudent: (state, action) => {
            state.chosenStudent = null
        },
        studentsSetConflicts: (state, action) => {
            state.conflicts = action.payload || [];
        },
        studentsSetConflictsLoading: (state, action) => {
            state.conflictsLoading = Boolean(action.payload);
        },
        studentsSetConflictsCheckedAt: (state, action) => {
            state.conflictsCheckedAt = action.payload || null;
        },
        studentsResetConflicts: (state, action) => {
            state.conflicts = [];
            state.conflictsCheckedAt = null;
        },
    },
})

const { actions, reducer } = studentsSlice;
export const {
    studentsSetAll,
    studentAddOne,
    studentUpdateOne,
    studentRemoveOne,
    addChosenStudent,
    removeChosenStudent,
    studentsSetConflicts,
    studentsSetConflictsLoading,
    studentsSetConflictsCheckedAt,
    studentsResetConflicts
} = actions;

export default reducer;
export const { selectAll } = studentsAdapter.getSelectors(state => state.students);


